const t = (a) => Array.isArray(a) ? a.length === 0 : a == null || a === "";
function n(a) {
  return a === void 0 || a === !1 ? [] : Array.isArray(a) ? a : [a];
}
export {
  t as isEmptyValue,
  n as toArray
};
//# sourceMappingURL=valueUtils.mjs.map
